<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <div class="article" v-html="article"></div>

  </div>

</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import {getAgreement} from "@/service/getData";

  export default {
    data(){
      return{
        article: ''
      }
    },
    computed: {
      ...mapState([
        'userInfo'
      ]),
    },
    created() {
      this.initData();

      var _mtac = {};
      (function() {
        var mta = document.createElement("script");
        mta.src = "//pingjs.qq.com/h5/stats.js?v2.0.4";
        mta.setAttribute("name", "MTAH5");
        mta.setAttribute("sid", "500694074");
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(mta, s);
      })();
    },
    methods: {

      async initData() {

        let id = this.$route.query.id;

        let res = await getAgreement({ id: id });

        if (res.errcode === '00000'){
          let protocol = res.data.protocol

          if (protocol != null){
            this.$route.meta.title = protocol.name;
            this.article = protocol.content;
          }
        }

      }
    },
    components: {

    },

  }

</script>

<style >

  .article{ padding: .24rem; color: #333; font-size: .3rem; }
  .article .MsoNormal,.article p{ line-height: .46rem; margin-top: .2rem; font-size: .3rem; }
  .article .MsoNormal b,.article p b{ line-height: .6rem; font-weight: 600; font-size: .36rem; padding: .5rem 0; }
  div img{ max-width: 100%; }

</style>



// WEBPACK FOOTER //
// src/page/agreement/agreement.vue